<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-car`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.19 5c1.032 0 1.883.83 1.94 1.89l1.405 12.109 1.557.001a2 2 0 011.998 1.906l1.692 17.074a2 2 0 01-1.99 2.197l-3.793-.001L40 43a1 1 0 01-1 1h-6a1 1 0 01-1-1l-.001-2.824h-16L16 43a1 1 0 01-1 1H9a1 1 0 01-1-1l-.001-2.824H4.208a2 2 0 01-1.99-2.196L3.91 20.906A2 2 0 015.908 19l1.555-.001 1.406-12.11C8.927 5.83 9.78 5 10.81 5h26.382zm3.087 18H7.722L6.416 36.177h35.168L40.277 23zM16 32v-5h-5v5h5zm21-5v5h-5v-5h5zM12.651 9H35.35l1.159 9.999H11.49L12.651 9z"/></svg>
</template>
<script>

export default {
  name: 'IconCar',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
